// @ts-check

import { useQuery } from '@/lib/tanstackQuery';
import { authKeys } from '@/queries/auth/queryKeys';
import { queryUserCurrentPreviewKey } from '@/queries/auth';

export function useUserCurrentPreviewKey() {
  const {
    isPending,
    isFetching,
    isError,
    data,
    error,
    refetch,
  } = useQuery({
    queryKey: authKeys.previewKey(),
    queryFn: queryUserCurrentPreviewKey,
  });

  return {
    previewKey: data,
    refetchPreviewKey: refetch,
    isPendingPreviewKey: isPending,
    isFetchingPreviewKey: isFetching,
    isErrorPreviewKey: isError,
    errorPreviewKey: error,
  };
}
